import useMarkAllAsAcknowledged from '../providers/ActivityAcknowledgement/useMarkAllAsAcknowledged';

export default useMarkAllAsAcknowledged;
